import { widgetComponents } from './widget-constants';

export const cloudEdgeWidgets = [
  {
    name: 'Top Applications',
    ...widgetComponents,
  },
  {
    name: 'Top Users',
    ...widgetComponents,
  },
  {
    name: 'Top Addresses',
    ...widgetComponents,
  },
  {
    name: 'Top Web Categories',
    ...widgetComponents,
  },
  {
    name: 'Observed Threats',
    ...widgetComponents,
  },
  {
    name: 'Top Intrusions',
    ...widgetComponents,
  },
  {
    name: 'Top Viruses',
    ...widgetComponents,
  },

  {
    name: 'Top Spyware',
    ...widgetComponents,
  },

  {
    name: 'Top Botnet',
    ...widgetComponents,
  },

  {
    name: 'Threat Insights',
    ...widgetComponents,
  },

  {
    name: 'Devices Summary by Location',
    ...widgetComponents,
  },

  {
    name: 'Devices Summary',
    ...widgetComponents,
  },
];
